// framework
import React, { useCallback, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { audio } from "services/audioManager";
import { sleep } from "utils/sleep";

// styles
import styles from "./RoundIntro.module.scss";

// components
import GameScreen from "components/Host/SubComponents/GameScreen/GameScreen";
import RoundSummary from "components/Host/Views/RoundIntro/RoundSummary/RoundSummary";

// constants
import { IMAGES, MESSAGES } from "constants/constants";
import { GAME_STATES } from "constants/constants";
import { MUSIC, VO } from "constants/audio";

const DELAY_AFTER_ROUND_INTRO_VO_MS = 1000;

async function runRoundIntroSequence({ signal, roundNumber, sendIfPrimary }) {
    if (signal.aborted) return;
    console.log(roundNumber);

    audio.playMusic(MUSIC.GAME_INTO_LOOP, { loop: true, signal: signal });

    await audio.playVo(VO.ROUND_INTRO[roundNumber], { timeoutMs: 5000, signal });

    if (signal.aborted) return;

    await sleep(DELAY_AFTER_ROUND_INTRO_VO_MS);

    if (!signal.aborted) {
        sendIfPrimary?.(MESSAGES.TO_SERVER.ROUND_INTRO_COMPLETE, { roundNumber });
    }
}

export default function RoundIntroView({ gameState, room, roomState, players, sendIfPrimary }) {
    const isActive = gameState === GAME_STATES.ROUND_INTRO;
    const roundNumber = roomState?.mdmdData?.roundNumber;

    // ROUND INTRO sequence (ensure loop, play VO, then stop loop at the end)
    useEffect(() => {
        if (!isActive) return;
        const ac = new AbortController();
        runRoundIntroSequence({ signal: ac.signal, roundNumber, sendIfPrimary });
        return () => ac?.abort();
    }, [isActive, roundNumber, sendIfPrimary]);

    return (
        <section className={styles.roundIntroView} data-show={isActive ? "true" : "false"} data-testid="round-intro-view" >
            <img src={IMAGES.HOST.roundIntroBackground} alt="" aria-hidden="true" className={styles.background} />

            <GameScreen className={`${styles.screen} ${isActive ? styles.show : ""}`}>
                <RoundSummary active={isActive} roundNumber={roundNumber} players={players} />
            </GameScreen>
        </section>
    );
}

RoundIntroView.propTypes = {
    gameState: PropTypes.any.isRequired,
    room: PropTypes.object,
    roomState: PropTypes.object,
    players: PropTypes.array,
};